(() => {
  const STYLE_ID = 'majbwr-care-guide-styles';
  const CARE_SELECTOR = '[data-majbwr-care-guide]';
  const normalize = (value = '') => value.replace(/\s+/g, ' ').trim();

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .product__description.rte p { margin: 0 0 14px; line-height: 1.65; }
      .product__description.rte p:last-child { margin-bottom: 0; }
      .product__description.rte h2,
      .product__description.rte h3,
      .product__description.rte h4,
      .product__description.rte h5,
      .product__description.rte h6 { margin: 22px 0 10px; line-height: 1.3; }
      .product__description.rte ul,
      .product__description.rte ol { margin: 0 0 14px; padding-inline-start: 1.25em; line-height: 1.6; }
      .product__description.rte li + li { margin-top: 6px; }

      .majbwr-care-guide {
        width: 100%; max-width: 100%; margin: 18px 0 0;
        border-top: 1px solid rgba(201,168,76,.24);
        border-bottom: 1px solid rgba(201,168,76,.14);
        box-sizing: border-box;
      }
      .majbwr-care-guide > summary {
        display: flex; align-items: center; justify-content: space-between; gap: 12px;
        min-height: 42px; padding: 10px 0; box-sizing: border-box; cursor: pointer;
        list-style: none; color: inherit; font-family: Georgia,'Times New Roman',serif;
        font-size: 11px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase;
      }
      .majbwr-care-guide > summary::-webkit-details-marker { display: none; }
      .majbwr-care-guide > summary::after {
        content: '+'; flex: 0 0 auto; font-family: Arial,Helvetica,sans-serif;
        font-size: 17px; font-weight: 400; line-height: 1;
      }
      .majbwr-care-guide[open] > summary::after { content: '−'; }
      .majbwr-care-guide__content {
        max-width: 100%; padding: 0 0 10px; box-sizing: border-box;
        font-size: 12px; line-height: 1.6; overflow-wrap: anywhere;
      }
      .majbwr-care-guide__content p,
      .majbwr-care-guide__content ul,
      .majbwr-care-guide__content ol { margin: 0 0 10px; }
      .majbwr-care-guide__content li + li { margin-top: 5px; }
      .majbwr-care-guide__content > *:last-child { margin-bottom: 0; }

      @media (max-width: 749px) {
        .product__description.rte p,
        .product__description.rte ul,
        .product__description.rte ol { margin-bottom: 12px; }
        .product__description.rte h2,
        .product__description.rte h3,
        .product__description.rte h4,
        .product__description.rte h5,
        .product__description.rte h6 { margin: 18px 0 8px; }
        .majbwr-care-guide { margin-top: 14px; }
        .majbwr-care-guide > summary { min-height: 40px; padding: 9px 0; font-size: 10px; }
        .majbwr-care-guide__content { padding-bottom: 9px; font-size: 11px; line-height: 1.55; }
      }
    `;
    document.head.appendChild(style);
  };

  const labelText = (value) => normalize(value).toLowerCase().replace(/[.:\-–—]+$/, '');
  const isCareLabel = (value) => [
    'care', 'care instruction', 'care instructions', 'fabric & care', 'fabric and care',
    'washing instruction', 'washing instructions', 'wash care', 'garment care', 'care guide'
  ].includes(labelText(value));

  const startsWithCareLabel = (value) => /^(?:care instructions?|fabric\s*(?:&|and)\s*care|washing instructions?|wash care|garment care|care guide)\s*[:\-–—]/i.test(normalize(value));
  const carePhraseCount = (value) => {
    const text = normalize(value).toLowerCase();
    const patterns = [
      /machine wash/, /hand wash/, /wash (?:cold|warm|inside out)/, /cold wash/,
      /tumble dry/, /hang dry/, /line dry/, /do not bleach/, /non-chlorine bleach/,
      /do not iron/, /iron (?:low|medium|high)/, /dry clean/, /do not dry clean/,
      /do not wring/, /wash with like colo(?:u)?rs/, /wash separately/, /remove promptly/,
      /low heat/, /gentle cycle/
    ];
    return patterns.reduce((count, pattern) => count + Number(pattern.test(text)), 0);
  };

  const isBoundary = (node) => {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches('table,[class*="size-guide"],[class*="size-chart"],[id*="size-guide"],[id*="size-chart"]')) return true;
    if (node.matches('h1,h2,h3,h4,h5,h6')) return true;
    const text = labelText(node.textContent || '');
    return /^(?:materials?|fabric composition|product details?|features?|size guide|size chart|shipping|returns?|shipping & returns|shipping and returns|ai (?:image )?disclaimer|eu representative|eu responsible person|product information)\b/.test(text);
  };

  const stripLeadingLabel = (node) => {
    if (!node || !startsWithCareLabel(node.textContent || '')) return;
    node.innerHTML = node.innerHTML.replace(
      /^\s*(?:<(?:strong|b)[^>]*>)?\s*(?:care instructions?|fabric\s*(?:&amp;|&|and)\s*care|washing instructions?|wash care|garment care|care guide)\s*[:\-–—]\s*(?:<\/(?:strong|b)>)?\s*/i,
      ''
    );
  };

  const findCareNodes = (description) => {
    const headings = Array.from(description.querySelectorAll('h2,h3,h4,h5,h6'));
    const heading = headings.find((node) => isCareLabel(node.textContent));

    if (heading) {
      const nodes = [];
      let next = heading.nextElementSibling;
      let inspected = 0;
      while (next && inspected < 10 && !isBoundary(next)) {
        const after = next.nextElementSibling;
        if (normalize(next.textContent) || next.querySelector('img')) nodes.push(next);
        next = after;
        inspected += 1;
      }
      if (nodes.length) return { heading, nodes };
    }

    const prefixed = Array.from(description.querySelectorAll('p,div,li')).find((node) => {
      if (node.closest('table,[class*="size-guide"],[class*="size-chart"],[id*="size-guide"],[id*="size-chart"]')) return false;
      return startsWithCareLabel(node.textContent || '');
    });
    if (prefixed) return { heading: null, nodes: [prefixed] };

    const laundry = Array.from(description.querySelectorAll('p,ul,ol')).find((node) => {
      if (node.closest('table,[class*="size-guide"],[class*="size-chart"],[id*="size-guide"],[id*="size-chart"]')) return false;
      const text = normalize(node.textContent);
      if (!text || text.length > 900) return false;
      const score = carePhraseCount(text);
      return score >= 2 || (score >= 1 && /care|washing|laundry/i.test(text));
    });
    return laundry ? { heading: null, nodes: [laundry] } : null;
  };

  const removeGenericCareAccordion = (product) => {
    product.querySelectorAll('.product-accordions details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      const text = labelText(summary?.textContent || '');
      if (text.includes('care') || text.includes('washing')) details.remove();
    });
  };

  const renderCare = (product) => {
    removeGenericCareAccordion(product);
    if (product.querySelector(CARE_SELECTOR)) return;

    const description = product.querySelector('.product__description');
    if (!description) return;
    const found = findCareNodes(description);
    if (!found?.nodes?.length) return;

    const details = document.createElement('details');
    details.className = 'majbwr-care-guide';
    details.dataset.majbwrCareGuide = '';

    const summary = document.createElement('summary');
    summary.textContent = 'CARE INSTRUCTIONS';
    const content = document.createElement('div');
    content.className = 'majbwr-care-guide__content';

    found.heading?.remove();
    found.nodes.forEach((node) => {
      if (!node.isConnected || !description.contains(node)) return;
      const parent = node.parentElement;
      stripLeadingLabel(node);
      content.appendChild(node);
      if (parent && parent !== description && !normalize(parent.textContent) && !parent.querySelector('img,table,video,iframe')) parent.remove();
    });

    if (!normalize(content.textContent)) return;
    details.append(summary, content);
    description.insertAdjacentElement('afterend', details);
  };

  const render = (scope = document) => {
    ensureStyles();
    const products = scope.matches?.('[data-product-context]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-product-context]') || []);
    products.forEach(renderCare);
  };

  const init = () => render(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => render(event.target));
})();
